import { fastdom } from "@devowl-wp/web-scoped-css";
export const SCALING_WHEN_WINDOW_WIDTH_LOWER = 700;
export * from "./types";
export * from "./stylesheet";
export { fastdom };